export default __webpack_public_path__ + "static/media/dotsloader.f8df8ee5.gif";